import { slice } from './slice'

const signRequestsActions = slice.actions

export default signRequestsActions
